import Axios from "./interceptor";
import { appApiBaseUrl } from "./appApiBaseUrl";

const API_URL = appApiBaseUrl + "/api";

const getSupportPlanLogsService = async (userId) => {
  const response = await Axios.get(
    `${API_URL}/CarePlanWizardDetail/get-user-support-plan-logs/${userId}`,
  );
  return response.data;
};

const getSupportPlanViewersService = async (carePlanId) => {
  const response = await Axios.get(
    `${API_URL}/CarePlanWizardDetail/get-support-plan-viewers/${carePlanId}`,
  );
  return response.data;
};

export { getSupportPlanLogsService, getSupportPlanViewersService };
